<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商户-商户详情
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--商户-->
      <div class="common-form">商户详情</div>
      <el-form-item label="会员昵称" prop="supplier.nickName">
        <el-input class="max-w460" :value="form.supplier.user?form.supplier.user.nickName:''" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="店铺名称" prop="supplier.store_name">
        <el-input class="max-w460" v-model="form.supplier.store_name" placeholder="请输入店铺名称" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="supplier.mobile" :rules="[{required: true,message: ' '}]">
        <el-input class="max-w460" v-model="form.supplier.mobile" placeholder="请输入账号" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="supplier.user_name">
        <el-input v-model="form.supplier.user_name" placeholder="姓名" type="text" class="max-w460" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="营业执照:">
        <el-row>
          <div v-if="form.supplier.business_id!=0" class="img">
            <el-image :src="form.supplier.businessImage.file_path" style="width: 100px; height: 100px"
              :preview-src-list="srcList" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="法人身份证正面:">
        <el-row>
          <div v-if="form.supplier.idcard_front_id && form.supplier.idcardFrontImage" class="img">
            <el-image :src="form.supplier.idcardFrontImage.file_path" style="width: 100px; height: 100px"
              :preview-src-list="frontSrcList" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="法人身份证反面:">
        <el-row>
          <div v-if="form.supplier.idcard_back_id && form.supplier.idcardBackImage" class="img">
            <el-image :src="form.supplier.idcardBackImage.file_path" style="width: 100px; height: 100px"
              :preview-src-list="backSrcList" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="主营业务" prop="supplier.category">
        <!-- <el-input class="max-w460" :value="form.supplier.category?form.supplier.category.name:''" :disabled="true"></el-input> -->
        <el-input class="max-w460" :value="(form.supplier.categories || []).map(item => item.name).join('、')" :disabled="true">
        </el-input>
      </el-form-item>
      <el-form-item label="所属行业">
        <el-input class="max-w460" :value="industryText(form.supplier.industry_code)" disabled></el-input>
      </el-form-item>
      <el-form-item label="省/市/区">
        <el-input class="max-w460" :value="regionText(form.supplier)" disabled></el-input>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input class="max-w460" :value="form.supplier.address || '-'" disabled></el-input>
      </el-form-item>
      <el-form-item label="经度/纬度">
        <el-input class="max-w460" :value="(form.supplier.longitude || '') + ' / ' + (form.supplier.latitude || '')" disabled></el-input>
      </el-form-item>
      <el-form-item label="合作意向">
        <el-input class="max-w460" :value="cooperativePurposeText(form.supplier.cooperative_purpose_type)" disabled></el-input>
      </el-form-item>
      <el-form-item label="加盟身份">
        <el-input class="max-w460" :value="franchiseeTypeText(form.supplier.franchisee_type)" disabled></el-input>
      </el-form-item>
      <el-form-item label="邀请码">
        <el-input class="max-w460" :value="form.supplier.inviter_code || '-'" disabled></el-input>
      </el-form-item>
      <el-form-item label="商家介绍" prop="supplier.description">
        <el-input
          type="textarea"
          v-model="form.supplier.description"
          class="max-w460"
          placeholder="请输入商家介绍"
          :rows="4"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">通过</el-radio>
          <el-radio :label="2">未通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注" prop="content">
        <el-input type="textarea" v-model="form.content" class="max-w460"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  import SupplierApi from '@/api/supplier.js';
  import request from '@/utils/request';
  import {
    formatModel
  } from '@/utils/base.js'
  import {
    fetchSupplierEnumOptions,
    displayCooperativePurpose,
    displayFranchiseeType,
    displayIndustry,
    FALLBACK_COOPERATIVE_PURPOSE_OPTIONS,
    FALLBACK_FRANCHISEE_TYPE_OPTIONS,
    FALLBACK_INDUSTRY_OPTIONS,
  } from '@/utils/supplierEnumOptions';
  export default {
    data() {
      return {
        /*form表单数据*/
        form: {
          supplier_apply_id: 0,
          supplier: {
            store_name: '',
            mobile: '',
            user_name: '',
            image_frontid: '',
            image_backid: '',
            idcard: '',
            user_id: '',
            logo_id: 0,
            business_id: 0,
            address: '',
            user: {},
            category: {},
            description: '',
            content: ''
          },
          content: '',
          status: 1,
        },
        imagefront_file_path: '',
        imageback_file_path: '',
        /*是否打开添加弹窗*/
        open_add: false,
        storeList: [],
        /*是否上传图片*/
        isupload: false,
        loading: false,
        type: 'logo',
        srcList: [],
        frontSrcList: [],
        backSrcList: [],
        // 省市区树（用于把 province_id/city_id/region_id 转成中文）
        regionOptions: [],
        industryOptions: [...FALLBACK_INDUSTRY_OPTIONS],
        cooperativePurposeOptions: [...FALLBACK_COOPERATIVE_PURPOSE_OPTIONS],
        franchiseeTypeOptions: [...FALLBACK_FRANCHISEE_TYPE_OPTIONS],
      };
    },
    created() {
      this.form.supplier_apply_id = this.$route.query.supplier_apply_id;
      Promise.all([
        this.loadRegionTree().catch(() => {}),
        fetchSupplierEnumOptions().then(opt => {
          this.industryOptions = opt.industryOptions
          this.cooperativePurposeOptions = opt.cooperativePurposeOptions
          this.franchiseeTypeOptions = opt.franchiseeTypeOptions
        }).catch(() => {})
      ]).finally(() => {
        this.getData();
      });
    },
    methods: {
      regionText(row) {
        if (!row) return '-';
        const path = [row.province_id, row.city_id, row.region_id].filter(Boolean);
        if (!path.length) return '-';
        const text = this.getRegionTextByPath(path);
        return text || '-';
      },
      industryText(code) {
        return displayIndustry(code, this.industryOptions);
      },
      // 根据 id 路径获取“省/市/区”中文文本
      getRegionTextByPath(path) {
        if (!Array.isArray(path) || !path.length || !this.regionOptions || !this.regionOptions.length) {
          return '';
        }
        let curOptions = this.regionOptions;
        const labels = [];
        for (const id of path) {
          const node = (curOptions || []).find(item => String(item.id) === String(id));
          if (!node) break;
          labels.push(node.name);
          curOptions = node.children || [];
        }
        return labels.length ? labels.join(' / ') : '';
      },
      // 加载地区树
      loadRegionTree() {
        return request._get('/shop/region.region/tree').then(res => {
          this.regionOptions = res.data.list || [];
          return this.regionOptions;
        });
      },
      cooperativePurposeText(v) {
        return displayCooperativePurpose(v, this.cooperativePurposeOptions);
      },
      franchiseeTypeText(v) {
        return displayFranchiseeType(v, this.franchiseeTypeOptions);
      },
      /*获取参数*/
      getData() {
        let self = this;
        SupplierApi.toAudit({
            supplier_apply_id: self.form.supplier_apply_id
          }, true)
          .then(res => {
            self.form.supplier = res.data.model;
            // 兼容后端未返回 description 的情况
            if (self.form.supplier && self.form.supplier.description == null) {
              self.form.supplier.description = '';
            }
            if (self.form.supplier.business_id != 0) {
              self.srcList.push(self.form.supplier.businessImage.file_path);
            }
            if (self.form.supplier.idcard_front_id && self.form.supplier.idcardFrontImage) {
              self.frontSrcList.push(self.form.supplier.idcardFrontImage.file_path);
            }
            if (self.form.supplier.idcard_back_id && self.form.supplier.idcardBackImage) {
              self.backSrcList.push(self.form.supplier.idcardBackImage.file_path);
            }
          })
          .catch(error => {

          });
      },

      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            SupplierApi.audit({
                supplier_apply_id: self.form.supplier_apply_id,
                status: self.form.status,
                content: self.form.content,
                description: self.form.supplier.description
              }, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，修改成功',
                    type: 'success'
                  });
                  self.$router.push('/supplier/supplier/apply');
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });
      },
      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/audit.vue